import PropTypes from 'prop-types';
import {
  LayoutGrid,
  Circle,
} from 'lucide-react';
import { Text } from '@/components/ui/index.js';
import styles from './SportFilter.module.css';

const sports = [
  { id: 'all', name: 'All', icon: LayoutGrid },
  { id: 'basketball', name: 'Basketball', icon: Circle },
  { id: 'soccer', name: 'Soccer', icon: Circle },
  { id: 'tennis', name: 'Tennis', icon: Circle },
  { id: 'running', name: 'Running', icon: Circle },
  { id: 'swimming', name: 'Swimming', icon: Circle },
  { id: 'cycling', name: 'Cycling', icon: Circle },
  { id: 'yoga', name: 'Yoga', icon: Circle },
];

/**
 * SportFilter - Horizontal scrollable list of sport categories
 * 
 * @param {string} selected - Currently selected sport ID
 * @param {function} onSelect - Callback when a sport is selected
 */
export function SportFilter({ selected, onSelect }) {
  return (
    <div className={styles.container}>
      <div className={styles.scroll}>
        <div className={styles.list}>
          {sports.map((sport, index) => {
            const Icon = sport.icon;
            const isActive = selected === sport.id;
            
            return (
              <button
                key={sport.id}
                className={`${styles.button} ${isActive ? styles.active : ''}`}
                onClick={() => onSelect(sport.id)}
                style={{ animationDelay: `${index * 50}ms` }}
                aria-pressed={isActive}
              >
                <Icon 
                  size={20} 
                  strokeWidth={2}
                  className={styles.icon}
                />
                <Text 
                  as="span" 
                  size="sm" 
                  weight="medium"
                  className={styles.label}
                >
                  {sport.name}
                </Text>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

SportFilter.propTypes = {
  selected: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default SportFilter;
